import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-done"]
const _hoisted_2 = { class: "Status__icon" }
const _hoisted_3 = { class: "Status__label" }

import { PropType } from "vue";
import { AdministrationStatus } from "@/types";
import Icon from "@/components/ds/icon/Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Status',
  props: {
    status: {
        type: Object as PropType<AdministrationStatus>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "Status",
    "data-done": __props.status.done
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.status.done === 'success')
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            "icon-id": "check"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.status.label), 1)
  ], 8, _hoisted_1))
}
}

})